import dayjs from "dayjs";

export const getDailyPlan = (datetime, volumes, turn = 1) => {
  const _datetime = dayjs(datetime).format('DD.MM.YYYY');
  try {
    return volumes[turn - 1][_datetime] || 0;
  } catch (e) {
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/utils/dayPlan.js